import { graphql } from "react-relay";

export const ORDER_HISTORY_FRAGMENT = graphql`
	fragment orderHistoryEvent_OrderHistoryFragment on HistoryEvent {
		kind
		when
		... on InvoiceSentEvent {
			invoiceId
			invoiceNumber
		}
		... on InvoiceEmailCorrectedEvent {
			previousInvoiceEmail
			newInvoiceEmail
			correctedByUserId
			correctedBy {
				name
				email
			}
		}
		... on ClaimEmailResentEvent {
			sentToInvoiceEmail
			sentByUserId
			sentBy {
				name
				email
			}
		}
		... on InvoiceResentEvent {
			invoiceNumber
			sentToInvoiceEmail
			sentByUserId
			sentBy {
				name
				email
			}
		}
		... on OrderClosedByAdminEvent {
			reason
			closedByUserId
			closedBy {
				name
				email
			}
		}
	}
`;
